import React from "react"
import { HiCurrencyDollar } from "react-icons/hi"
import styled from "styled-components"
const MI_ic_location_pin = props => {
  const { fill } = props
  return (
    <svg
      width="18"
      height="26"
      viewBox="0 0 18 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.37595 25.266C8.51505 25.4747 8.74925 25.6 9 25.6C9.25075 25.6 9.48495 25.4747 9.62405 25.266C11.399 22.6037 14.0134 19.3156 15.8352 15.9715C17.2919 13.2978 18 11.0173 18 9C18 4.0374 13.9626 0 9 0C4.0374 0 0 4.0374 0 9C0 11.0173 0.70815 13.2978 2.16485 15.9715C3.9853 19.3131 6.60465 22.6091 8.37595 25.266ZM9 1.5C13.1355 1.5 16.5 4.8645 16.5 9C16.5 10.7602 15.8517 12.8059 14.518 15.254C12.9476 18.1364 10.7067 21.0604 9 23.5184C7.29355 21.0607 5.0525 18.1366 3.48205 15.254C2.14835 12.8059 1.5 10.7602 1.5 9C1.5 4.8645 4.8645 1.5 9 1.5Z"
        fill={fill || "#B7B7B7"}
      />
      <path
        d="M9 13.5C11.4813 13.5 13.5 11.4813 13.5 9C13.5 6.5187 11.4813 4.5 9 4.5C6.5187 4.5 4.5 6.5187 4.5 9C4.5 11.4813 6.5187 13.5 9 13.5ZM9 6C10.6542 6 12 7.3458 12 9C12 10.6542 10.6542 12 9 12C7.3458 12 6 10.6542 6 9C6 7.3458 7.3458 6 9 6Z"
        fill={fill || "#B7B7B7"}
      />
    </svg>
  )
}
export default MI_ic_location_pin
